/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const goal = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m7.5 8.406 2.78-2.778m0 0 .38-2.5L12.82 1l.34 1.75 1.75.334-2.13 2.165-2.5.379ZM8.158 2.033A6.5 6.5 0 1 0 13.982 8M7.497 5a3.5 3.5 0 1 0 3.467 3m-6.871 6-.5 2m7.5-2 .5 2"
    />
  </svg>
)
export default goal
